function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10{fill:none;stroke-miterlimit:10;}.cls-1{stroke:#29abe2;stroke-linecap:round;stroke-width:4px;}.cls-2{fill:#1a1a1a;}.cls-3{fill:#f2f2f2;}.cls-4{fill:#363636;}.cls-5{fill:#fff;}.cls-6{fill:#da4f00;}.cls-7{fill:#f79b12;}.cls-8{fill:#2bcb71;}.cls-9{opacity:0.5;isolation:isolate;}.cls-10{stroke:#333;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "info"
}, /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 113.71,
  y1: 316.52,
  x2: 113.71,
  y2: 408.52
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.38,328.09l1.28,22.55h-2.15l-.84-12.43c0-.75-.08-1.55-.12-2.41s-.07-1.67-.09-2.47,0-1.48-.06-2.06,0-1,0-1.16l-4.18,16.42h-2.5l-4.48-16.42v1.21c0,.61,0,1.33,0,2.14s0,1.64,0,2.48-.05,1.58-.08,2.23l-.74,12.47h-2.1l1.28-22.55H133l4,15.7,3.83-15.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.21,337a1.3,1.3,0,0,1-2.59,0,1.3,1.3,0,0,1,2.59,0Zm0,12.74a1.3,1.3,0,1,1-1.31-1.28A1.25,1.25,0,0,1,151.21,349.71Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.18,350.64H181.7l.42-10.72c.13-3.55.29-7.62.48-9.76L174.31,348h-1.47l-3.42-17.82c-.39,2.08-1.38,6.27-2.18,9.66l-2.56,10.79h-1.44l5.22-21.89h2.08l3.26,17.47,8-17.47H184Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.22,335l-1.76,12.09c-.2,1.54-.13,2.4,1,2.85L201,351c-1.31-.39-2.14-1.09-2-3.11a6.39,6.39,0,0,1-5.22,3.11c-3.29,0-5.25-2.47-5.25-6.5,0-4.51,2.28-10.88,8.48-10.88A10.32,10.32,0,0,1,202.22,335Zm-12.07,9.5c0,3.42,1.41,5.25,3.84,5.25,2.15,0,3.75-1.38,5.19-3.71l1.47-10.31a7,7,0,0,0-3.55-.86C192,334.83,190.15,340.56,190.15,344.46Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.17,338.83l-1.67,11.81H217l1.67-11.75c.38-2.81-.58-4-2.56-4-2.6,0-4.74,2.5-6.53,5.79l-1.41,10h-1.47l2.37-16.71h1.24l-.48,4.48c1.7-3,4-4.8,6.53-4.8C219.24,333.61,220.65,335.53,220.17,338.83Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M240,327.12l-3.33,23.52h-1.25l.29-3.62c-1.18,2.08-3,4-5.69,4-3.14,0-5.09-2.47-5.09-6.56,0-4.35,2-10.82,7.84-10.82a5,5,0,0,1,4.48,2.37l1.28-9.05Zm-13.5,17.34c0,3.42,1.4,5.25,3.71,5.25,2.59,0,4.19-2,5.82-4.83l1-7.43a4.38,4.38,0,0,0-4.09-2.59C228.17,334.86,226.54,340.59,226.54,344.46Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M244.9,344v.32c0,3.81,1.83,5.41,4.48,5.41a7.68,7.68,0,0,0,4.8-1.73l.71,1.05a9,9,0,0,1-5.57,2c-3.74,0-5.95-2.4-5.95-6.69,0-4.7,2.53-10.69,8.48-10.69,3,0,4.83,1.67,4.83,3.94C256.68,341.71,252,343.47,244.9,344Zm.1-1.22c6.66-.48,10.14-2,10.14-5.12,0-1.5-1-2.75-3.29-2.75C247.46,334.86,245.41,339,245,342.73Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.8,348c-.16,1.12.13,1.7,1.12,1.7a3.75,3.75,0,0,0,1.25-.26l.35,1.15a4.31,4.31,0,0,1-1.79.42c-1.73,0-2.69-1-2.37-3.2l2.91-20.67,1.47-.19Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M283,339.85c0,4.52-2.08,11.14-8.51,11.14a14.07,14.07,0,0,1-5.34-1.09l3.23-22.78,1.47-.19-1.28,9.28a7.29,7.29,0,0,1,5.41-2.6C281.16,333.61,283,335.79,283,339.85Zm-10.65-2L270.82,349a8.68,8.68,0,0,0,3.72.74c5.37,0,7-6.11,7-9.92,0-3.33-1.38-4.93-3.74-4.93S273.9,336.14,272.36,337.84Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.45,333.84l-.42,1.34a5.42,5.42,0,0,0-1.31-.19c-2.59,0-4.13,2.27-5.6,5.89l-1.41,9.76h-1.47l2.37-16.71h1.28l-.52,4.29c1.25-2.88,2.95-4.61,5.48-4.61A5.27,5.27,0,0,1,297.45,333.84Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M298.69,344.27c0-4.26,2.05-10.66,8.26-10.66,3.74,0,5.92,2.37,5.92,6.63s-2,10.75-8.26,10.75C300.87,351,298.69,348.46,298.69,344.27Zm12.64-4.1c0-3.48-1.6-5.31-4.41-5.31-5.15,0-6.69,5.92-6.69,9.51s1.6,5.31,4.42,5.31C309.73,349.68,311.33,343.88,311.33,340.17Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M319.11,346.64c-.29,2,.32,3,2.08,3a6.24,6.24,0,0,0,2.82-.8l.54,1.08a6.76,6.76,0,0,1-3.52,1c-2.4,0-3.81-1.51-3.39-4.32l1.63-11.49h-2.82l.2-1.25h2.81l.87-4.09,1.15-.13-.58,4.22h4.39l-.36,1.25h-4.22Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M347.78,335.44l-.8.89a6.43,6.43,0,0,0-4.19-1.47c-2.5,0-4.16,1.15-4.16,3.07,0,1.44.83,2.34,3.74,3.24,3.33,1.05,4.67,2.4,4.67,4.76,0,2.82-2.17,5.06-6.33,5.06a8,8,0,0,1-5.79-2.21l.86-.9a7.22,7.22,0,0,0,4.9,1.8c2.91,0,4.83-1.28,4.83-3.65,0-1.79-.83-2.72-3.94-3.68-3.42-1.06-4.44-2.37-4.44-4.38,0-2.44,2.2-4.36,5.66-4.36A7.08,7.08,0,0,1,347.78,335.44Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.77,344v.32c0,3.81,1.83,5.41,4.48,5.41a7.66,7.66,0,0,0,4.8-1.73l.71,1.05a9,9,0,0,1-5.57,2c-3.74,0-5.95-2.4-5.95-6.69,0-4.7,2.53-10.69,8.48-10.69,3,0,4.83,1.67,4.83,3.94C364.55,341.71,359.88,343.47,352.77,344Zm.1-1.22c6.66-.48,10.14-2,10.14-5.12,0-1.5-1-2.75-3.29-2.75C355.33,334.86,353.29,339,352.87,342.73Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369.93,346.64c-.29,2,.31,3,2.07,3a6.2,6.2,0,0,0,2.82-.8l.55,1.08a6.79,6.79,0,0,1-3.52,1c-2.4,0-3.81-1.51-3.4-4.32l1.63-11.49h-2.81l.19-1.25h2.82l.86-4.09,1.15-.13-.57,4.22h4.38l-.35,1.25h-4.22Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.1,372V387.2a11.76,11.76,0,0,1-.3,2.58,7.48,7.48,0,0,1-1.09,2.49,5.86,5.86,0,0,1-2.22,1.86,8.18,8.18,0,0,1-3.68.71,10.15,10.15,0,0,1-3.1-.51,9.69,9.69,0,0,1-2.9-1.52l1-1.46a10.24,10.24,0,0,0,2.83,1.28,9.31,9.31,0,0,0,2.19.31,4.65,4.65,0,0,0,3.85-1.62A6.77,6.77,0,0,0,141,387V373.79H134.4V372Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.21,380.84a1.3,1.3,0,1,1-1.31-1.28A1.25,1.25,0,0,1,151.21,380.84Zm0,12.73a1.3,1.3,0,0,1-2.59,0,1.3,1.3,0,0,1,2.59,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167,391.65c-.54,3.65-1.82,5-5.56,6.47l-.36-1.16c3.08-1.34,4-2.49,4.39-5.5l2.65-18.85h1.54Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.09,389.67l1.66-11.87h1.47l-1.66,11.84c-.38,2.75.64,3.93,2.59,3.93,2.69,0,4.8-2.53,6.34-5.76l1.4-10h1.48L185,394.5h-1.19l.52-4.64c-1.41,2.88-3.59,5-6.4,5S173.64,392.93,174.09,389.67Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.74,391.84c-.16,1.12.12,1.7,1.12,1.7a3.69,3.69,0,0,0,1.24-.26l.35,1.15a4.24,4.24,0,0,1-1.79.42c-1.72,0-2.68-1-2.36-3.2L195.21,371l1.47-.19Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.44,394.5H201l2.37-16.7h1.47Zm1.34-22.56a1.21,1.21,0,0,1,1.25-1.25,1,1,0,0,1,1,1,1.21,1.21,0,0,1-1.22,1.25A1,1,0,0,1,203.78,371.94Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222.73,378.82,221,390.92c-.2,1.53-.13,2.4,1,2.84l-.42,1.09c-1.31-.38-2.14-1.09-2-3.1a6.4,6.4,0,0,1-5.22,3.1c-3.29,0-5.24-2.46-5.24-6.49,0-4.52,2.27-10.88,8.47-10.88A10.32,10.32,0,0,1,222.73,378.82Zm-12.07,9.5c0,3.43,1.41,5.25,3.84,5.25,2.15,0,3.75-1.37,5.19-3.71l1.47-10.3a6.88,6.88,0,0,0-3.55-.87C212.49,378.69,210.66,384.42,210.66,388.32Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.24,379.3l-.8.9a6.45,6.45,0,0,0-4.19-1.48c-2.5,0-4.16,1.16-4.16,3.08,0,1.44.83,2.33,3.74,3.23,3.33,1.05,4.67,2.4,4.67,4.76,0,2.82-2.17,5.06-6.33,5.06a8,8,0,0,1-5.79-2.21l.86-.89a7.24,7.24,0,0,0,4.9,1.79c2.91,0,4.83-1.28,4.83-3.65,0-1.79-.84-2.72-3.94-3.68-3.42-1-4.45-2.37-4.45-4.38,0-2.43,2.21-4.35,5.67-4.35A7.11,7.11,0,0,1,247.24,379.3Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M252.23,387.81v.32c0,3.81,1.82,5.41,4.48,5.41a7.68,7.68,0,0,0,4.8-1.73l.7,1.06a9,9,0,0,1-5.56,2c-3.75,0-6-2.4-6-6.69,0-4.7,2.53-10.68,8.48-10.68,3,0,4.84,1.66,4.84,3.93C264,385.57,259.33,387.33,252.23,387.81Zm.1-1.21c6.65-.48,10.14-2,10.14-5.12,0-1.51-1-2.76-3.3-2.76C254.79,378.72,252.74,382.88,252.33,386.6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M269.38,390.5c-.28,2,.32,3,2.08,3a6.2,6.2,0,0,0,2.82-.8l.54,1.09a6.72,6.72,0,0,1-3.52,1c-2.4,0-3.81-1.5-3.39-4.32L269.54,379h-2.81l.19-1.24h2.82l.86-4.1,1.15-.13-.58,4.23h4.39l-.35,1.24H271Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "l"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M244.65,277.51h11.44l-.52,1.76H242.45l3.88-27.35h1.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M277.45,259.68l-2.2,15.11c-.24,1.92-.16,3,1.24,3.56l-.52,1.36c-1.64-.48-2.68-1.36-2.48-3.88a8,8,0,0,1-6.52,3.88c-4.12,0-6.56-3.08-6.56-8.12,0-5.63,2.84-13.59,10.6-13.59A12.87,12.87,0,0,1,277.45,259.68Zm-15.08,11.87c0,4.28,1.76,6.56,4.8,6.56,2.68,0,4.68-1.72,6.48-4.64l1.84-12.87a8.68,8.68,0,0,0-4.44-1.08C264.65,259.52,262.37,266.67,262.37,271.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M299.89,264.51l-2.08,14.76H296l2.08-14.68c.48-3.51-.72-5-3.2-5-3.24,0-5.92,3.11-8.16,7.23l-1.76,12.48h-1.84l3-20.87h1.56L287,264c2.12-3.76,5-6,8.16-6C298.73,258,300.49,260.4,299.89,264.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M324.73,249.88l-4.16,29.39H319l.36-4.52c-1.48,2.6-3.72,5-7.12,5-3.92,0-6.36-3.08-6.36-8.2,0-5.44,2.52-13.51,9.8-13.51a6.2,6.2,0,0,1,5.6,3l1.6-11.32Zm-16.88,21.67c0,4.28,1.76,6.56,4.64,6.56,3.24,0,5.24-2.52,7.28-6l1.28-9.28a5.51,5.51,0,0,0-5.12-3.23C309.89,259.56,307.85,266.71,307.85,271.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M343,260.28l-1,1.12a8,8,0,0,0-5.24-1.84c-3.12,0-5.2,1.44-5.2,3.84,0,1.8,1,2.91,4.68,4,4.16,1.32,5.84,3,5.84,6,0,3.52-2.72,6.32-7.92,6.32a10,10,0,0,1-7.24-2.76l1.08-1.12a9,9,0,0,0,6.12,2.24c3.64,0,6-1.6,6-4.56,0-2.24-1-3.4-4.92-4.6-4.28-1.32-5.56-3-5.56-5.47,0-3,2.76-5.44,7.08-5.44A8.89,8.89,0,0,1,343,260.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M363.13,260.08l-1.08,1.16a6.2,6.2,0,0,0-4.44-1.68c-6.24,0-8.36,7.11-8.36,11.83,0,4.52,2.16,6.64,5.6,6.64a8.91,8.91,0,0,0,5.24-1.8l.84,1.32a10,10,0,0,1-6.16,2.16c-4.52,0-7.44-3-7.44-8.4S350.09,258,357.65,258A7.39,7.39,0,0,1,363.13,260.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M382.93,259.68l-2.2,15.11c-.24,1.92-.16,3,1.24,3.56l-.52,1.36c-1.64-.48-2.68-1.36-2.48-3.88a8,8,0,0,1-6.52,3.88c-4.12,0-6.56-3.08-6.56-8.12,0-5.63,2.84-13.59,10.6-13.59A12.87,12.87,0,0,1,382.93,259.68Zm-15.08,11.87c0,4.28,1.76,6.56,4.8,6.56,2.68,0,4.68-1.72,6.48-4.64L381,260.6a8.68,8.68,0,0,0-4.44-1.08C370.13,259.52,367.85,266.67,367.85,271.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M391.53,258.4h1.6l-.24,3a9.12,9.12,0,0,1,6.84-3.36c4,0,6.28,2.72,6.28,7.79,0,5.64-2.56,13.92-10.6,13.92a12.66,12.66,0,0,1-4.92-.92l-1.2,8.36-1.84.24Zm12.6,7.31c0-4.19-1.68-6.15-4.68-6.15s-4.84,1.56-6.72,3.72l-2,13.91a10.85,10.85,0,0,0,4.64.92C402.13,278.11,404.13,270.47,404.13,265.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M412.85,270.91v.4c0,4.76,2.28,6.76,5.6,6.76a9.6,9.6,0,0,0,6-2.16l.88,1.32a11.29,11.29,0,0,1-7,2.48c-4.68,0-7.44-3-7.44-8.36,0-5.88,3.16-13.35,10.6-13.35,3.8,0,6,2.08,6,4.92C427.57,268.11,421.73,270.31,412.85,270.91Zm.12-1.52c8.32-.6,12.68-2.51,12.68-6.39,0-1.88-1.28-3.44-4.12-3.44C416.05,259.56,413.49,264.75,413,269.39Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "browser"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rounded_Rectangle_1",
  "data-name": "Rounded Rectangle 1",
  className: "cls-3",
  d: "M184.78,13.93H485.22A4.77,4.77,0,0,1,490,18.69V211.31a4.77,4.77,0,0,1-4.78,4.76H184.78a4.77,4.77,0,0,1-4.78-4.76V18.69A4.77,4.77,0,0,1,184.78,13.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Top_dark",
  "data-name": "Top dark",
  className: "cls-4",
  d: "M184.78,13.93H485.22A4.77,4.77,0,0,1,490,18.69V30.57H180V18.69A4.77,4.77,0,0,1,184.78,13.93Z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Adressbar",
  className: "cls-5",
  x: 243.8,
  y: 17.74,
  width: 193.39,
  height: 9.51,
  rx: 2.41
}), /*#__PURE__*/React.createElement("g", {
  id: "Circles_2",
  "data-name": "Circles 2"
}, /*#__PURE__*/React.createElement("circle", {
  id: "_1",
  "data-name": 1,
  className: "cls-6",
  cx: 188.56,
  cy: 22.49,
  r: 2.38
}), /*#__PURE__*/React.createElement("circle", {
  id: "_2",
  "data-name": 2,
  className: "cls-7",
  cx: 197.12,
  cy: 22.49,
  r: 2.38
}), /*#__PURE__*/React.createElement("circle", {
  id: "_3",
  "data-name": 3,
  className: "cls-8",
  cx: 205.68,
  cy: 22.49,
  r: 2.38
})), /*#__PURE__*/React.createElement("image", {
  id: "menu_light",
  "data-name": "menu light",
  className: "cls-9",
  width: 16,
  height: 13,
  transform: "translate(472.79 19.16) scale(0.48 0.48)",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAAACXBIWXMAABc4AAAXOAGuwzgqAAAAP0lEQVQoU2P8//+/LwMDAzMDeeAv4////wkpwguYCCkgBIaBASwMDAzBDAwMrIQU4gC/R2OBCgawMDAwUJQXANvLDQCp8gj+AAAAAElFTkSuQmCC"
})), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 334.15,
  y1: 216.07,
  x2: 334.15,
  y2: 30.57
}), /*#__PURE__*/React.createElement("path", {
  d: "M423.92,95.37v31.44a24,24,0,0,1-.63,5.34,14.92,14.92,0,0,1-2.25,5.12,11.76,11.76,0,0,1-4.57,3.84,16.83,16.83,0,0,1-7.58,1.48,20.69,20.69,0,0,1-6.4-1.07,19.92,19.92,0,0,1-6-3.13l2.13-3a20.86,20.86,0,0,0,5.84,2.64,19.37,19.37,0,0,0,4.52.64c3.5,0,6.14-1.12,7.94-3.35s2.69-5.22,2.69-9V99.16H406V95.37Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M272.41,95.37l2.64,46.51h-4.44l-1.72-25.63c-.09-1.55-.18-3.21-.26-5s-.14-3.46-.18-5.09-.09-3.06-.12-4.25-.06-2-.09-2.41l-8.63,33.88h-5.14l-9.24-33.88c0,.41,0,1.25,0,2.51s0,2.74,0,4.42,0,3.38-.07,5.11-.1,3.25-.17,4.58l-1.52,25.73H239.1l2.64-46.51H249l8.26,32.39,7.89-32.39Z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "p"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M26.75,258.72c0,4.87-2.56,9.71-11.28,9.71H11.31L9.79,279.27H7.87l3.88-27.35h6.08C23.51,251.92,26.75,254,26.75,258.72Zm-2,0c0-3.8-2.6-5.16-7.12-5.16H13.39l-1.84,13.19h4.08C22.91,266.75,24.79,262.79,24.79,258.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M29.87,271.31C29.87,266,32.43,258,40.19,258c4.68,0,7.4,3,7.4,8.27s-2.48,13.44-10.32,13.44C32.59,279.71,29.87,276.55,29.87,271.31Zm15.8-5.12c0-4.36-2-6.63-5.52-6.63-6.44,0-8.36,7.39-8.36,11.87s2,6.64,5.52,6.64C43.67,278.07,45.67,270.83,45.67,266.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M65.67,258.28,65.15,260a6.45,6.45,0,0,0-1.64-.24c-3.24,0-5.16,2.84-7,7.35l-1.76,12.2H52.91l3-20.87h1.6l-.64,5.35c1.56-3.59,3.68-5.75,6.84-5.75A6.66,6.66,0,0,1,65.67,258.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M70.11,274.27c-.36,2.52.4,3.8,2.6,3.8a7.77,7.77,0,0,0,3.52-1l.68,1.36a8.43,8.43,0,0,1-4.4,1.28c-3,0-4.76-1.88-4.24-5.4l2-14.35H66.79L67,258.4h3.52l1.08-5.12,1.44-.16-.72,5.28h5.48L77.39,260H72.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M93.71,258.28,93.19,260a6.45,6.45,0,0,0-1.64-.24c-3.24,0-5.16,2.84-7,7.35l-1.76,12.2H81l3-20.87h1.6l-.64,5.35c1.56-3.59,3.68-5.75,6.84-5.75A6.66,6.66,0,0,1,93.71,258.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M112.27,259.68l-2.2,15.11c-.24,1.92-.16,3,1.24,3.56l-.52,1.36c-1.64-.48-2.68-1.36-2.48-3.88a8,8,0,0,1-6.52,3.88c-4.12,0-6.56-3.08-6.56-8.12,0-5.63,2.84-13.59,10.6-13.59A12.87,12.87,0,0,1,112.27,259.68ZM97.19,271.55c0,4.28,1.76,6.56,4.8,6.56,2.68,0,4.68-1.72,6.48-4.64l1.84-12.87a8.68,8.68,0,0,0-4.44-1.08C99.47,259.52,97.19,266.67,97.19,271.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M119.75,279.27h-1.84l3-20.87h1.84Zm1.68-28.19a1.51,1.51,0,0,1,1.56-1.56,1.19,1.19,0,0,1,1.28,1.24,1.5,1.5,0,0,1-1.52,1.56A1.22,1.22,0,0,1,121.43,251.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M131,274.27c-.36,2.52.4,3.8,2.6,3.8a7.77,7.77,0,0,0,3.52-1l.68,1.36a8.43,8.43,0,0,1-4.4,1.28c-3,0-4.76-1.88-4.24-5.4l2-14.35h-3.52l.24-1.56h3.52l1.08-5.12,1.44-.16-.72,5.28h5.48l-.44,1.56H133Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "browser-2",
  "data-name": "browser"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rounded_Rectangle_1-2",
  "data-name": "Rounded Rectangle 1",
  className: "cls-3",
  d: "M4.86,0H135.14A4.8,4.8,0,0,1,140,4.75v220.5a4.8,4.8,0,0,1-4.86,4.75H4.86A4.8,4.8,0,0,1,0,225.25V4.75A4.8,4.8,0,0,1,4.86,0Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Top_dark-2",
  "data-name": "Top dark",
  className: "cls-4",
  d: "M4.86,0H135.14A4.8,4.8,0,0,1,140,4.75V16.64H0V4.75A4.8,4.8,0,0,1,4.86,0Z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Adressbar-2",
  "data-name": "Adressbar",
  className: "cls-5",
  x: 39.23,
  y: 3.8,
  width: 72.7,
  height: 9.51,
  rx: 2.41
}), /*#__PURE__*/React.createElement("g", {
  id: "Circles_2-2",
  "data-name": "Circles 2"
}, /*#__PURE__*/React.createElement("circle", {
  id: "_1-2",
  "data-name": 1,
  className: "cls-6",
  cx: 8.56,
  cy: 8.56,
  r: 2.38
}), /*#__PURE__*/React.createElement("circle", {
  id: "_2-2",
  "data-name": 2,
  className: "cls-7",
  cx: 17.12,
  cy: 8.56,
  r: 2.38
}), /*#__PURE__*/React.createElement("circle", {
  id: "_3-2",
  "data-name": 3,
  className: "cls-8",
  cx: 25.68,
  cy: 8.56,
  r: 2.38
})), /*#__PURE__*/React.createElement("image", {
  id: "menu_light-2",
  "data-name": "menu light",
  className: "cls-9",
  width: 16,
  height: 13,
  transform: "translate(122.52 5.23) scale(0.49 0.48)",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAAACXBIWXMAABbCAAAWwgFTLGrhAAAAQElEQVQoU+2RzQ0AEBTG6m8pOzjZfxLhMwEvESfRc9NLnaQCBM7oTpIlbfGWYPFAIAIVSJa4oP0LFwIRyJyHxgTXDAztklk6XgAAAABJRU5ErkJggg=="
})), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  y1: 123.32,
  x2: 140,
  y2: 123.32
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.94,152.94l2.4,42.28h-4l-1.57-23.3c-.08-1.41-.16-2.92-.23-4.52s-.13-3.14-.17-4.63-.08-2.77-.11-3.86-.06-1.82-.08-2.19l-7.84,30.8H67.63l-8.4-30.8c0,.37,0,1.13,0,2.28s0,2.49,0,4,0,3.07-.06,4.64-.09,3-.16,4.17L57.6,195.22H53.66l2.4-42.28h6.56l7.5,29.44,7.17-29.44Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.54,46.26V74.84A21.86,21.86,0,0,1,81,79.69a13.31,13.31,0,0,1-2,4.66,10.64,10.64,0,0,1-4.15,3.49,15.29,15.29,0,0,1-6.89,1.34,18.68,18.68,0,0,1-5.82-1,18,18,0,0,1-5.44-2.84l1.93-2.74A18.87,18.87,0,0,0,63.86,85a17.61,17.61,0,0,0,4.11.58q4.77,0,7.21-3a12.6,12.6,0,0,0,2.45-8.16V49.71H65.23V46.26Z"
}));

function SvgLayoutDiagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 410.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutDiagram);
export default __webpack_public_path__ + "static/media/layout-diagram.5c92978a.svg";
export { ForwardRef as ReactComponent };